(() => {
  if (!window.storewide_sale || !window.storewide_sale.amount || !window.storewide_sale.type) {
    return;
  }

  const storewideAmount = parseFloat(window.storewide_sale.amount);
  const storewideType = window.storewide_sale.type;

  delete window.storewide_sale;

  const idInputElement = document.querySelector('input[name="id"]');
  const compareAtPrices = document.querySelectorAll('[data-section-type="product"] [data-compare-price]');
  const prices = document.querySelectorAll('[data-section-type="product"] [data-product-price]');

  if (compareAtPrices.length !== prices.length) {
    console.log('We encountered an unexpected error.');
  }

  if (!idInputElement || !compareAtPrices || !prices) {
    return;
  }

  window.applyStorewideSale = function () {
    compareAtPrices.forEach((compareAtPrice, index) => {
      const price = prices[index];

      const currentCompareAtPrice = parseFloat(compareAtPrice.textContent.replace('$', '').replace(',', ''));
      const currentPrice = parseFloat(price.textContent.replace('$', '').replace(',', ''));

      let variantPrice;

      switch (storewideType) {
        case 'percent':
          const saleMultiplier = (100 - storewideAmount) / 100;
          variantPrice = Math.round(currentPrice * saleMultiplier);
          break;
        case 'fixed':
          variantPrice = Math.round(currentPrice - storewideAmount);
          break;
      }

      console.log(variantPrice);

      variantPrice = `${variantPrice <= 0 ? 'Free' : '$' + variantPrice.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;

      price.textContent = variantPrice;
      compareAtPrice.textContent = `$${currentPrice.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;

      compareAtPrice.classList.remove('hidden');
      price.classList.add('product__price--sale');
    });
  }
})();